import { useReCaptcha } from 'vue-recaptcha-v3'

export function useRecaptchaToken() {
    const { executeRecaptcha, recaptchaLoaded } = useReCaptcha();

    const getRecaptchaToken = async () => {
        await recaptchaLoaded();
        return await executeRecaptcha('login');
    }

    return {
        getRecaptchaToken
    }
}